export enum GoodStockType {
Available,
Reserved,
AtSupplier,
}
